// extracted by mini-css-extract-plugin
module.exports = {"row":"PaginationRow_row__GuapU","content":"PaginationRow_content__1tzG0"};